import createRoutePath from '@api/endpoints/createEndpointPath';

import { store } from '@app/redux/store';

import { getBranchRoutes } from '@utils/environment';

const generateRoutePath = () => {
	const branchEnvironment = store.getState().branchEnvironment.variables;
	let URLPattern = '/:branchRoute/:repRoute/';
	let queryString = '';
	if (branchEnvironment.is_branch_from_query_params) {
		URLPattern = '/';
		const { branch_id, rep_code, auth_form_slug } = branchEnvironment;
		queryString = `?${new URLSearchParams({
			branch_id: String(branch_id),
			...(rep_code && { rep_code: String(rep_code) }),
			auth_form_slug,
		}).toString()}`;
	}

	return {
		AUTH: {
			LOGIN: createRoutePath(`${URLPattern}login`, queryString),
			USER_EXISTS: createRoutePath(`${URLPattern}user-exists`, queryString),
			TERMSANDCONDITIONS: createRoutePath(`${URLPattern}terms-and-conditions`, queryString),
			FORGOT_PASSWORD_METHOD: createRoutePath(`${URLPattern}forgot-password-method`, queryString),
			FORGOT_PASSWORD_VIA_EMAIL: createRoutePath(`${URLPattern}forgot-password/email`, queryString),
			FORGOT_PASSWORD_VIA_PHONE: createRoutePath(`${URLPattern}forgot-password/sms`, queryString),
			FORGOT_PASSWORD_VIA_VOICE: createRoutePath(`${URLPattern}forgot-password/voice`, queryString),
			RESET_PASSWORD: createRoutePath(`${URLPattern}reset-password`, queryString),
			REGISTRATION: createRoutePath(`${URLPattern}registration`, queryString),
		},
		VERIFICATION: {
			ACCOUNT: createRoutePath(`${URLPattern}verification/account`, queryString),
			MFA_SETUP: createRoutePath(`${URLPattern}verification/mfa-setup`, queryString),
			MFA_VERIFY: createRoutePath(`${URLPattern}verification/mfa-verify`, queryString),
		},
		MAIN: {
			APPLICATIONS: createRoutePath(`${URLPattern}applications`, queryString),
			APPLICATION_FORM: createRoutePath(`${URLPattern}applications/forms`, queryString),
		},
	};
};

const RoutePaths = generateRoutePath();

export const UNAUTHORIZED_ROUTES = getBranchRoutes().reduce((branchRoutes: string[], branchRoute) => {
	const branchInfo = { branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route };
	return [
		...branchRoutes,
		RoutePaths.AUTH.LOGIN(branchInfo),
		RoutePaths.AUTH.USER_EXISTS(branchInfo),
		RoutePaths.AUTH.TERMSANDCONDITIONS(branchInfo),
		RoutePaths.AUTH.FORGOT_PASSWORD_METHOD(branchInfo),
		RoutePaths.AUTH.FORGOT_PASSWORD_VIA_EMAIL(branchInfo),
		RoutePaths.AUTH.FORGOT_PASSWORD_VIA_PHONE(branchInfo),
		RoutePaths.AUTH.FORGOT_PASSWORD_VIA_VOICE(branchInfo),
		RoutePaths.AUTH.RESET_PASSWORD(branchInfo),
		RoutePaths.AUTH.REGISTRATION(branchInfo),
	];
}, []);

export const AUTHORIZED_ROUTES = getBranchRoutes().reduce(
	(branchRoutes: string[], branchRoute) => [
		...branchRoutes,
		RoutePaths.MAIN.APPLICATIONS({ branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route }),
		RoutePaths.MAIN.APPLICATION_FORM({ branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route }),
	],
	[],
);

export const VERIFICATION_ROUTES = getBranchRoutes().reduce((branchRoutes: string[], branchRoute) => {
	return [
		...branchRoutes,
		RoutePaths.VERIFICATION.ACCOUNT({ branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route }),
		RoutePaths.VERIFICATION.MFA_SETUP({ branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route }),
		RoutePaths.VERIFICATION.MFA_VERIFY({ branchRoute: branchRoute.branch_route, repRoute: branchRoute.rep_route }),
	];
}, []);

export default RoutePaths;
